import React from 'react'
import { Helmet } from 'react-helmet'

const SeoCsLearning = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com/education/countersketch' />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "CounterSketch Learning",
            "description": "Training programs for first-time CAD users. Whether you are a novice, expert, student, or professional, we have a training path for you. Choose the option best suited to your style of learning.",
            "item": "https://gemvision.com/education/countersketch"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoCsLearning
